export default __webpack_public_path__ + "static/media/location.1e5622a8.svg";